
<template>
  <div>
    <v-list dense>
      <v-list-tile v-for="(gol, i) in goalPapers" :key="i" avatar>
        <v-list-tile-action># {{gol.shirt}}</v-list-tile-action>
        <v-list-tile-action>
          <v-icon :color="gol.kind=='gol contra'? 'red' : 'black'">mdi-soccer</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title
            v-text="gol.kind=='gol'? gol.player : gol.kind=='gol contra'? 'gol contra!' : ''"
          ></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list dense>
      <v-list-tile v-for="(card, i) in cardPapers" :key="i" avatar>
        <v-list-tile-action># {{card.shirt}}</v-list-tile-action>
        <v-list-tile-action>
          <v-icon
            class="mdi-rotate-90"
            :color="card.kind=='cartão amarelo'? 'yellow' : 'red'"
          >mdi-card</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="card.player"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: ["goalPapers", "cardPapers"],
  data() {
    return {
      key: null
    };
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    ...mapState({})
  },
  watch: {}
};
</script>

<style scoped>
</style>